import axios from 'axios';

var instanciaAxios=axios.create({
baseURL: 'https://facturacionquadrumguadalajara-colima.com.mx/banobras-gc-backend/'
//baseURL: 'https://quadrumdesarrollo.com.mx/banobras-gc-backend/'
//baseURL: 'http://localhost:8080/banobras-gc-backend/'
});

instanciaAxios.interceptors.request.use(function (config) {
 // console.log("****** Interceptor request *********");
 let tokenkey = localStorage.getItem("token_gc");
  let token=localStorage.getItem("auth");  
  if (token) {
    if (config.method !== 'OPTIONS') {
         // console.log("token",token);
          let autorizacion="Bearer "+token;
          config.headers.authorization = autorizacion;

          if(tokenkey)
          config.headers.tokenkey = tokenkey;
    }
  }
  document.body.classList.add('loading-indicator');     
  return config;
}, function (error) {
  document.body.classList.remove('loading-indicator');
  return Promise.reject(error);
});

instanciaAxios.interceptors.response.use(function (response) {
  //console.log("****** Interceptor response *********");
  document.body.classList.remove('loading-indicator');
  return response;
}, function (error) {
  document.body.classList.remove('loading-indicator');
  return Promise.reject(error);
});

export default instanciaAxios;